export default "__VITE_ASSET__mEyJ5THi__"